module.exports = __webpack_public_path__ + "static/img/2-3-4.dac62e36.jpg";